import { jsx } from "panel";
export function template() {
  return /* @__PURE__ */ jsx("div", {
    sel: ".mp-progress-bar-container"
  }, /* @__PURE__ */ jsx("div", {
    sel: ".mp-progress-bar-status",
    style: {
      width: `${this.helpers.getPercentStatus()}%`
    }
  }));
}
